import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Contains Organization Space Assignment: The association(s) between organizational units and space. ',
    name: 'Organization Space Assignments',
    partialId: PartialId.Standard.create('org_space'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
